/**
 * jai1 tasks ready [-P parent] [-j]
 */
import { Command } from 'commander';
import chalk from 'chalk';
import { TaskService } from '../../services/task.service.js';
import { PRIORITY_ICONS, type TaskReadyOptions } from '../../types/task.types.js';

export function createTaskReadyCommand(): Command {
    return new Command('ready')
        .description('Show tasks ready to pick (not blocked, not assigned)')
        .option('-P, --parent <parent>', 'Filter by parent')
        .option('-j, --json', 'Output JSON')
        .action(async (options: TaskReadyOptions) => {
            const service = new TaskService();
            const tasks = await service.getReady(options.parent);

            if (options.json) {
                console.log(JSON.stringify(tasks, null, 2));
                return;
            }

            if (tasks.length === 0) {
                console.log(chalk.dim('No tasks ready to pick.'));
                console.log(chalk.dim('💡 Check blocked tasks: jai1 t list -s todo'));
                return;
            }

            console.log(chalk.bold(`📋 Ready to pick (${tasks.length} tasks):`));
            console.log();

            for (const task of tasks) {
                const icon = PRIORITY_ICONS[task.priority] || '🟡';
                let line = `  P${task.priority}${icon}  ${chalk.dim(task.id)}  ${task.title}`;
                if (task.parent) {
                    line += chalk.dim(`  [${task.parent}]`);
                }
                console.log(line);
            }

            console.log();
            console.log(chalk.dim('💡 Run: jai1 t pick'));
        });
}
